if (!customElements.get("product-form-sticky")) {
  customElements.define(
    "product-form-sticky",
    class ProductFormSticky extends HTMLElement {
      constructor() {
        super()

        this.form = this.querySelector(".product-form__buttons a")
        this.form.addEventListener("click", this.onSubmitHandler.bind(this))
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        document.querySelector("product-form .js-product-form button[type='submit']").click()
        return false
      }

      connectedCallback() {
        this.stickyBounds = {}
        this.submitButton = document.querySelector(
          "product-form .js-product-form button[type='submit']"
        )

        this.preventReveal = false

        this.onScrollHandler = this.onScroll.bind(this)
        this.hideStickyOnScrollUp = () => (this.preventReveal = true)

        this.addEventListener("preventStickyReveal", this.hideStickyOnScrollUp)
        window.addEventListener("scroll", this.onScrollHandler, false)

        this.createObserver()

        if (document.querySelector('product-form-sticky')) {
          document.addEventListener("change", (e) => {
            if (e.target.name === "purchaseOption") {
              // g) update sticky ATC savings badge
              const stickyATCPriceEl = document.querySelector('.js-sticky-atc-price')
              const stickyATCSalePriceEl = document.querySelector('.js-sticky-atc-sale-price')
              const activeOriginalPrice = document.querySelector(
                ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc_original__price"
              )?.innerText
              const activeSalePrice = document.querySelector(
                ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc_sale__price"
              )?.innerText
              const activePrice = document.querySelector(
                ".recharge-subscription-widget .rc-widget .rc-radio.rc-radio--active .rc-radio__price"
              )?.innerText
              
              if (activeOriginalPrice && activeSalePrice) {
                stickyATCPriceEl.innerText = activeOriginalPrice
                stickyATCSalePriceEl.innerText = activeSalePrice
                stickyATCSalePriceEl.classList.remove("hidden")
              } else {
                stickyATCPriceEl.innerText = activePrice
                stickyATCSalePriceEl.classList.add("hidden")
              }
            }
  
            if (e.target?.name === 'id' && e.detail?.variant?.featured_image) {
              const thumbnail = document.querySelector('.product-form__sticky-atc--thumbnail > picture > img') ?? document.querySelector('.product-form__sticky-atc--thumbnail > img')
              thumbnail?.removeAttribute('srcset')
              thumbnail?.setAttribute('src', e.detail?.variant?.featured_image.src)
            }
          })
        }
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.stickyBounds = entries[0].intersectionRect
          observer.disconnect()
        })

        observer.observe(this)
      }

      disconnectedCallback() {
        this.removeEventListener("preventStickyReveal", this.hideStickyOnScrollUp)
        window.removeEventListener("scroll", this.onScrollHandler)
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const offsetPositionButton = this.submitButton.offsetTop

        if (scrollTop < offsetPositionButton) {
          if (this.preventHide) return
          requestAnimationFrame(this.hide.bind(this))
        } else if (scrollTop > offsetPositionButton && scrollTop > this.stickyBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.show.bind(this))
          } else {
            window.clearTimeout(this.isScrolling)

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false
            }, 66)

            requestAnimationFrame(this.hide.bind(this))
          }
        } else if (scrollTop <= this.stickyBounds.top) {
          requestAnimationFrame(this.reset.bind(this))
        }
      }

      show() {
        this.classList.add("shopify-section-sticky", "animate")
        document.querySelector('sticky-header')?.classList.add('visibility-hidden')
      }

      hide() {
        this.classList.remove("shopify-section-sticky", "animate")
        document.querySelector('sticky-header')?.classList.remove('visibility-hidden')
      }

      reset() {
        this.classList.remove("shopify-section-sticky", "animate")
        document.querySelector('sticky-header')?.classList.remove('visibility-hidden')
      }
    }
  )
}
